<template>
  <div>
    <SalesSlipDetail></SalesSlipDetail>
  </div>
</template>
<script>
export default {
  name: "SalesOrderDetail",
  data() {
    return {
    };
  },
  components: {
    SalesSlipDetail: resolve => require(["@/components/OrderFolder/StoreSale/SalesSlipDetail.vue"], resolve), // 销售单申请详情组件
  },
  watch: {
  },
  methods: {
    
  },
  created() {
  },
  mounted() {
    
  },
  destroyed() {
    
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/SalesOrderDetail.vue